
import { ControllerInterface } from "csi/action/Controller";
import { MoveFromInterface } from "csi/action/MoveFromController";
import comm from "csi/comm";
import def from "csi/def";
import locale from "csi/locale";
import NewFrom from "csi/table/NewFrom";
import xml from "csi/xml";
import { CallMethod } from "csi/xml/CallMethod";
import Writer from "csi/xml/Writer";
import declare from "dojo/_base/declare";
import _ from "lodash";

const NewFromFoodSKUController = declare(NewFrom, {
	// Success message for new from food sku
	successMessageTemplateSingular: "CreateFoodSKU_SuccessSingular",
	successMessageTemplatePlural: "CreateFoodSKU_SuccessPlural",

	// String: name of field containing number of nodes to create
	numCreateField: "CopyCount",
	numCreated: 0,
	_controller: null,

	constructor() {
		this.numCreated = 0;
		this._controller = this as unknown as ControllerInterface;
	},

	/**
	 * @override
	 * Control mass create behavior for New From FoodSKU
	 */
	toWriterRequest(): CallMethod {
		const call = this.inherited<CallMethod>(arguments);

		const fd = this.m_formData;
		call.addParameter("CopyCount", xml.ATTR_INTEGER, fd.getFieldValue("CopyCount", true));
		call.addParameter("FromSKU", xml.ATTR_REF, this.m_nodeSource.$URL);
		call.addParameter("Node Name", xml.ATTR_STRING, fd.getFieldValue("Node Name", true));
		call.addParameter("FPSProductSalesRegion", xml.ATTR_REF, fd.getFieldValue("FPSProductSalesRegion", true));
		call.addParameter("Project", xml.ATTR_REF, fd.getFieldValue("Project", true));
		call.addParameter("AutoGTIN", xml.ATTR_BOOLEAN, fd.getFieldValue("AutoGTIN", true));

		_.forEach(fd.getFields(), (field) => {
			const fieldId = field.idParameter || field.m_id;
			if (fieldId && !field.m_bUsed) {
				call.addGeneralizedParameter(fieldId, field.getType(), field.getValue());
				field.m_bUsed = true;
			}
		});

		return call;
	},

	/**
	 * @override
	 * Overridden to prevent ValidateAndDeleteIfFailed call on frontend, validation is handled in java operation
	 */
	_toWriterValidateNode() {
		const w: Writer = this.m_writer;

		w.flushChanges();
	},

	/**
	 * @override
	 * Control multi-create behavior for FoodSKU
	 */
	_writeRequestParameters(call) {
		const controller = this as unknown as MoveFromInterface;

		const numCreate = parseInt(this._controller.m_formData.getFieldValue(this.numCreateField, true));
		const numURLs = isNaN(numCreate) ? 1 : numCreate;

		const urls = comm.createUrls(numURLs);
		this.numCreated += numURLs;
		call.addParameter("URLs", xml.ATTR_REFLIST, urls);
		controller.m_value = urls;

		this.inherited(arguments);
	},

	/**
	 * @override
	 * Disable Save&Go button for NewFromFoodSKU action
	 * @returns boolean for if button should be displayed
	 */
	_canNavigate: function () {
		return def.canNavigateToType(this.m_typeNode) && !this.widget.bPopup;
	},

	/**
	 * @override
	 * Format string to display 
	 */
	getSuccess() {
		if (this.numCreated == 0) {
			return this.inherited(arguments);
		}

		const templateString = this.numCreated == 1 ? this.successMessageTemplateSingular : this.successMessageTemplatePlural;
		return locale.resource(templateString, [this.numCreated]);
	},
});

export = NewFromFoodSKUController;
